import { Outlet, useMatches } from 'react-router'
import Sidebar from './components/Sidebar'
import Header from './components/Header'
import clsx from 'clsx'
import { H5DefaultLayout, LAYOUT, PcDedaultLayout } from './constant'
import { useUserStore } from '@/store/user/useUserStore'
import { useEffect } from 'react'
import LastLoginModal from '@/views/Login/LastLoginModal'
import NiceModal from '@ebay/nice-modal-react'

const RootLayout = () => {
  const matches = useMatches()
  // 找到最後一個匹配 route 的 handle
  const currentHandle: any = matches[matches.length - 1]?.handle
  // layout 模式
  const layoutMode = currentHandle?.layout ?? PcDedaultLayout | H5DefaultLayout

  useEffect(() => {
    const token = useUserStore.getState()?.token
    if (!token) return
    // 使用者資訊
    const user = useUserStore.getState()?.userInfo
    if (!user?.lastLoginDate) {
      // 顯示 "密码更新提示" 彈窗
      NiceModal.show(LastLoginModal)
    }
  }, [])

  return (
    <div className="relative flex h-full w-full flex-col">
      {/* h5 頂部欄 */}
      {!!(layoutMode & LAYOUT.H5_HEADER) && <Header />}

      <div
        className={clsx('flex flex-1 bg-[#EDEEF0] sm:pt-0', {
          // 有 h5 的 header
          'pt-header': layoutMode & LAYOUT.H5_HEADER,
        })}>
        {/* 側邊欄 */}
        {!!((layoutMode & LAYOUT.PC_SIDEBAR) | (layoutMode & LAYOUT.H5_SIDEBAR)) && <Sidebar layoutMode={layoutMode} />}

        <div
          className={clsx('flex w-full flex-1', {
            // pc 側邊欄寬度
            'sm:pl-280': layoutMode & LAYOUT.PC_SIDEBAR,
          })}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default RootLayout
